import { useEffect, useState } from "react";

import "./App.scss";
import Step1 from "./pages/Steps/step1";
import Step2 from "./pages/Steps/step2";
import Step3 from "./pages/Steps/step3";
import Welcome from "./pages/Welcome";
import generateTokenService from "./services/auth/generate-token";
import getListDocumentTypesService from "./services/document-type/list";
import { message } from "./utils/message";
import { PAYMENT_METHOD, SELECT_PLACEHOLDERS } from "./config/config";
import IMAGE_1 from "./images/Pantalla1.jpg";
import IMAGE_2 from "./images/Pantalla2.jpg";
import IMAGE_3 from "./images/Pantalla3.jpg";
import IMAGE_4 from "./images/4.png";
import IMAGE_1_MOBILE from "./images/Pantalla1-mobile.jpg";
import IMAGE_2_MOBILE from "./images/Pantalla2-mobile.jpg";
import IMAGE_3_MOBILE from "./images/Pantalla3-mobile.jpg";
import IMAGE_4_MOBILE from "./images/Pantalla4-mobile.jpg";

import IMAGE_1_cursos from "./images/Pantalla1-cursos.jpg";
import IMAGE_2_cursos from "./images/Pantalla2-cursos.jpg";
import IMAGE_3_cursos from "./images/Pantalla3-cursos.jpg";
import IMAGE_4_cursos from "./images/4-cursos.png";

import IMAGE_1_MOBILE_cursos from "./images/Pantalla1-mobile-cursos.jpg";
import IMAGE_2_MOBILE_cursos from "./images/Pantalla2-mobile-cursos.jpg";
import IMAGE_3_MOBILE_cursos from "./images/Pantalla3-mobile-cursos.jpg";
import IMAGE_4_MOBILE_cursos from "./images/Pantalla4-mobile-cursos.jpg";

import IMAGE_1_salud from "./images/salud-1.webp";
import IMAGE_2_salud from "./images/salud-2.webp";
import IMAGE_3_salud from "./images/salud-3.webp";
import IMAGE_4_salud from "./images/Pantalla4-salud.jpg";

import IMAGE_1_MOBILE_salud from "./images/Pantalla1-mobile-salud.jpg";
import IMAGE_2_MOBILE_salud from "./images/Pantalla2-mobile-salud.jpg";
import IMAGE_3_MOBILE_salud from "./images/Pantalla3-mobile-salud.jpg";
import IMAGE_4_MOBILE_salud from "./images/Pantalla4-mobile-salud.jpg";


import IMAGE_1_postgrado from "./images/Pantalla1-postgrado.jpg";
import IMAGE_2_postgrado from "./images/Pantalla2-postgrado.jpg";
import IMAGE_3_postgrado from "./images/Pantalla3-postgrado.jpg";
// import IMAGE_4_postgrado from './images/4-postgrado.png';
import IMAGE_1_MOBILE_postgrado from "./images/Pantalla1-mobile-postgrado.jpg";
import IMAGE_2_MOBILE_postgrado from "./images/Pantalla2-mobile-postgrado.jpg";
import IMAGE_3_MOBILE_postgrado from "./images/Pantalla3-mobile-postgrado.jpg";
import IMAGE_4_MOBILE_postgrado from "./images/Pantalla4-mobile-postgrado.jpg";

import IMAGE_LOGO_UCASAL from "./images/logo-edcontinua-blanco.svg";

import { ToastProvider } from "./hooks/toast";
import {
  FaFacebook,
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
  FaLinkedin,
  FaYoutube,
} from "react-icons/fa";
import {
  onlyIscriptionBySector,
  onlyIscriptionCourses,
  onlyIscriptionPostGrado,
  onlyIscriptions,
} from "./utils/app_manage";
import { loadFormState } from "./utils/formStorage";

function App() {
  const [x, setX] = useState(0);
  const [step, setStep] = useState(0);
  const [token, setToken] = useState(null);

  const [generateFullPayment, setGenerateFullPayment] = useState(false);

  const [step1Data, setstep1Data] = useState({
    document_type: "",
    document_number: "",
    name: "",
    surname: "",
    email: "",
    whatsapp_prefix: "",
    whatsapp_number: "",
  });

  const [yearSelected, setYearSelected] = useState({
    value: "",
    label: SELECT_PLACEHOLDERS.year,
  });
  const [carrerSelected, setCarrerSelected] = useState({
    value: "",
    label: SELECT_PLACEHOLDERS.carrer,
  });
  const [placeSelected, setPlaceSelected] = useState({
    value: "",
    label: SELECT_PLACEHOLDERS.place,
  });
  const [modeSelected, setModeSelected] = useState({
    value: "",
    label: SELECT_PLACEHOLDERS.mode,
  });
  const [sectorSelected, setSectorSelected] = useState({
    value: "",
    label: SELECT_PLACEHOLDERS.sector,
  });
  const [document_types, setDocumentTypes] = useState([]);

  const [payment_method, setPaymentMethod] = useState(PAYMENT_METHOD.online.id);
  const [invoiceData, setInvoiceData] = useState();

  const [loading, setLoading] = useState(false);

  const [loadingDocumentList, setLoadingDocumentList] = useState(true);
  const [disabledDocumentList, setDisabledDocumentList] = useState(true);
  const [errorDocumentList, setErrorDocumentList] = useState("");

  const [boleta, setBoleta] = useState(null);
  const [boletaGenerada, setBoletaGenerada] = useState(null);

  const [params, setParams] = useState(null);

  useEffect(() => {
    setInterval(() => {
      // console.log(`token invalido ${new Date().toISOString()}`);
      generateTokenService({
        callbacks: (response) => {
          if (response.success) {
            const { token } = response.data;
            setToken(token);
          } else {
            message(response);
          }
        },
      });
    }, 480000);

    generateTokenService({
      callbacks: (response) => {
        if (response.success) {
          const { token } = response.data;
          setToken(token);
          const result = ["DNI-LE-LC", "C.I.", "Pasaporte", "Otros", "D.U."];
          setDocumentTypes(
            result.map((item) => ({ value: item, label: item }))
          );
          setLoadingDocumentList(false);
          setDisabledDocumentList(false);
          // getListDocumentTypesService({
          //     token, callbacks: (result) => {
          //         if (result.success) {
          //             setDocumentTypes(result.data.map(item => ({ value: item, label: item })));
          //             setLoadingDocumentList(false);
          //             setDisabledDocumentList(false);
          //         } else {
          //             setErrorDocumentList(result.message ?? result.error[0]);
          //             message(result);
          //             setLoadingDocumentList(false);
          //             setDisabledDocumentList(true);
          //         }
          //     }
          // });
        } else {
          message(response);
        }
      },
    });
  }, []);
  let BACKGROUND_IMAGES = [];
  if (onlyIscriptions()) {
    BACKGROUND_IMAGES = {
      0: {
        destktop: IMAGE_1,
        mobile: IMAGE_1_MOBILE,
      },
      1: {
        destktop: IMAGE_2,
        mobile: IMAGE_2_MOBILE,
      },
      2: {
        destktop: IMAGE_3,
        mobile: IMAGE_3_MOBILE,
      },
      3: {
        destktop: IMAGE_4,
        mobile: IMAGE_4_MOBILE,
      },
    };
  }

  if (onlyIscriptionCourses() && !onlyIscriptionBySector()) {
    BACKGROUND_IMAGES = {
      0: {
        destktop: IMAGE_1_cursos,
        mobile: IMAGE_1_MOBILE_cursos,
      },
      1: {
        destktop: IMAGE_2_cursos,
        mobile: IMAGE_2_MOBILE_cursos,
      },
      2: {
        destktop: IMAGE_3_cursos,
        mobile: IMAGE_3_MOBILE_cursos,
      },
      3: {
        destktop: IMAGE_4_cursos,
        mobile: IMAGE_4_MOBILE_cursos,
      },
    };
  }

  if (onlyIscriptionCourses() && onlyIscriptionBySector()==13) {
    BACKGROUND_IMAGES = {
      0: {
        destktop: IMAGE_1_salud,
        mobile: IMAGE_1_MOBILE_salud,
      },
      1: {
        destktop: IMAGE_2_salud,
        mobile: IMAGE_2_MOBILE_salud,
      },
      2: {
        destktop: IMAGE_3_salud,
        mobile: IMAGE_3_MOBILE_salud,
      },
      3: {
        destktop: IMAGE_4_salud,
        mobile: IMAGE_4_MOBILE_salud,
      },
    };
  }

  if (onlyIscriptionPostGrado()) {
    BACKGROUND_IMAGES = {
      0: {
        destktop: IMAGE_1_postgrado,
        mobile: IMAGE_1_MOBILE_postgrado,
      },
      1: {
        destktop: IMAGE_2_postgrado,
        mobile: IMAGE_2_MOBILE_postgrado,
      },
      2: {
        destktop: IMAGE_3_postgrado,
        mobile: IMAGE_3_MOBILE_postgrado,
      },
      3: {
        destktop: IMAGE_4_MOBILE_postgrado,
        mobile: IMAGE_4_MOBILE_postgrado,
      },
    };
  }

  const MENSAJES_ERROR = {
    apellido: {
      display:
        "Apellido es obligatorio. Vuelve al primer paso para completar tu inscripcion",
    },
    nombre: {
      display:
        "Nombre es obligatorio. Vuelve al primer paso para completar tu inscripcion",
    },
    tdocu: {
      display:
        "El tipo de documento es obligatorio. Vuelve al primer paso para completar tu inscripcion",
    },
    ndocu: {
      display:
        "Numero de documento es obligatorio. Vuelve al primer paso para completar tu inscripcion",
    },
    codTelefono: {
      display:
        "Codigo de telefono es obligatorio. Vuelve al primer paso para completar tu inscripcion",
    },
    telefono: {
      display:
        "Telefono es obligatorio. Vuelve al primer paso para completar tu inscripcion",
    },
    email: {
      display:
        "Email es obligatorio. Vuelve al primer paso para completar tu inscripcion",
    },
    tipoEstudio: {
      display:
        "Tipo de estudio es obligatorio. Actualiza la pagina para completar tu inscripcion",
    },
    anio: {
      display:
        "Año de estudio es obligatorio. Vuelve al segundo paso para completar tu inscripcion",
    },
    carrera: {
      display:
        `${onlyIscriptionCourses()? 'Capacitación': 'Carrera'} es obligatorio. Vuelve al segundo paso para completar tu inscripcion`,
    },
    lugar: {
      display:
        "Lugar es obligatorio. Vuelve al segundo paso para completar tu inscripcion",
    },
    modo: {
      display:
        "Modo es obligatorio. Vuelve al segundo paso para completar tu inscripcion",
    },
    sector: {
      display:
        "Sector es obligatorio. Vuelve al segundo paso para completar tu inscripcion",
    },
  };

  const COMPONENT_LIST = [
    {
      render: (
        <Step1
          setStep={setStep}
          step={step}
          token={token}
          document_types={document_types}
          step1Data={step1Data}
          setstep1Data={setstep1Data}
          loadingDocumentList={loadingDocumentList}
          setLoadingDocumentList={setLoadingDocumentList}
          disabledDocumentList={disabledDocumentList}
          setDisabledDocumentList={setDisabledDocumentList}
          errorDocumentList={errorDocumentList}
          x={x}
          setX={setX}
          loading={loading}
          setLoading={setLoading}
          MENSAJES_ERROR={MENSAJES_ERROR}
        />
      ),
      background_class: "background-image-step background-step1",
    },
    {
      render: (
        <Step2
          setStep={setStep}
          step={step}
          token={token}
          setToken={setToken}
          step1Data={step1Data}
          yearSelected={yearSelected}
          carrerSelected={carrerSelected}
          placeSelected={placeSelected}
          modeSelected={modeSelected}
          sectorSelected={sectorSelected}
          setYearSelected={setYearSelected}
          setCarrerSelected={setCarrerSelected}
          setPlaceSelected={setPlaceSelected}
          setModeSelected={setModeSelected}
          setSectorSelected={setSectorSelected}
          x={x}
          setX={setX}
          loading={loading}
          setLoading={setLoading}
          MENSAJES_ERROR={MENSAJES_ERROR}
          boleta={boleta}
          setBoleta={setBoleta}
          params={params}
          setParams={setParams}
          boletaGenerada={boletaGenerada}
          setBoletaGenerada={setBoletaGenerada}
          generateFullPayment={generateFullPayment}
          setGenerateFullPayment={setGenerateFullPayment}
        />
      ),
      background_class: "background-image-step background-step2",
    },
    {
      render: (
        <Step3
          setStep={setStep}
          step={step}
          token={token}
          step1Data={step1Data}
          yearSelected={yearSelected}
          carrerSelected={carrerSelected}
          placeSelected={placeSelected}
          modeSelected={modeSelected}
          sectorSelected={sectorSelected}
          payment_method={payment_method}
          setPaymentMethod={setPaymentMethod}
          setInvoiceData={setInvoiceData}
          x={x}
          setX={setX}
          loading={loading}
          setLoading={setLoading}
          MENSAJES_ERROR={MENSAJES_ERROR}
          boleta={boleta}
          setBoleta={setBoleta}
          params={params}
          setParams={setParams}
          boletaGenerada={boletaGenerada}
          setBoletaGenerada={setBoletaGenerada}
          generateFullPayment={generateFullPayment}
        />
      ),
      background_class: "background-image-step background-step3",
    },
    {
      render: (
        <Welcome
          setStep={setStep}
          token={token}
          payment_method={payment_method}
          invoiceData={invoiceData}
          x={x}
          loading={loading}
          setLoading={setLoading}
          setstep1Data={setstep1Data}
          setPaymentMethod={setPaymentMethod}
          setInvoiceData={setInvoiceData}
        />
      ),
      background_class: "background-image-step background-welcome",
    },
  ];

  useEffect(() => {
    const saved = loadFormState();  
    if (saved) {
      if (saved.step !== undefined) setStep(1);
      if (saved.step1Data) setstep1Data(saved.step1Data);

      if (saved.yearSelected) setYearSelected(saved.yearSelected);
      if (saved.carrerSelected) setCarrerSelected(saved.carrerSelected);
      if (saved.placeSelected) setPlaceSelected(saved.placeSelected);
      if (saved.modeSelected) setModeSelected(saved.modeSelected);
    }
  }, []);

  return (
    <>
      <ToastProvider>
        {step >= 0 && step <= 4 && (
          <>
            {onlyIscriptionCourses() && !onlyIscriptionBySector() && (
              <div className="not-show-curses-text">
                {step != 2 && (
                  <div
                    className="logo-container"
                    style={{ backgroundImage: `url(${IMAGE_LOGO_UCASAL})` }}
                  ></div>
                )}
                {step === 0 && (
                  <div className="title-text">
                    <p>
                      ¡APRENDE <br /> ALGO NUEVO!
                    </p>
                  </div>
                )}
              </div>
            )}
            <div
              className={
                COMPONENT_LIST[step].background_class ??
                COMPONENT_LIST[0].background_class
              }
              style={{
                backgroundImage:
                  `url(${
                    window.innerWidth >= 700
                      ? BACKGROUND_IMAGES[step].destktop
                      : BACKGROUND_IMAGES[step].mobile
                  })` || "",
              }}
            >
              {COMPONENT_LIST[step].render ?? COMPONENT_LIST[0].render}
            </div>
          </>
        )}
        {(step < 0 || step > 4) &&
          (COMPONENT_LIST[step].render ?? COMPONENT_LIST[0].render)}
      </ToastProvider>
    </>
  );
}

export default App;
